import { render, staticRenderFns } from "./InventoriesCompanyLocations.vue?vue&type=template&id=e95b40e8&"
import script from "./InventoriesCompanyLocations.vue?vue&type=script&lang=ts&"
export * from "./InventoriesCompanyLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports